import { resource } from '@/plugins/http'

export default resource('/v1/settings/me/tenants')



// WEBPACK FOOTER //
// ./src/store/resources/tenants.js